import EventEmitter from 'eventemitter3';
import { Settings } from '../Settings';
import { MediaProducer } from '../engine/mediaproducer/MediaProducer';
import { ViewerCounter } from './helpers/ViewerCounter';
import { StreamrWrapper } from './streamr/StreamrWrapper';
export class StreamrTvBroadcaster extends EventEmitter {
    streamrWrapper;
    mediaProducer;
    viewerCounter;
    viewerInfoIntervalRef;
    streamId;
    constructor(aesKey) {
        super();
        this.streamrWrapper = new StreamrWrapper(aesKey);
        this.mediaProducer = new MediaProducer();
        this.viewerCounter = new ViewerCounter();
        this.mediaProducer.on('mediaPacketFragment', (mediaPacketFragment) => {
            this.streamrWrapper.publishMediaPacketFragment(mediaPacketFragment);
        });
        this.mediaProducer.on('audioVolume', (volume) => {
            this.emit('audioVolume', volume);
        });
        this.viewerCounter.on('countChanged', (count) => {
            if (this.streamId) {
                this.emit('viewerCountChanged', this.streamId, count);
            }
        });
        this.streamrWrapper.on('heartbeat', (heartbeat) => this.viewerCounter.handleHeartbeat(heartbeat));
        this.streamrWrapper.on('leave', (leave) => this.viewerCounter.handleLeave(leave));
    }
    async start(streamId) {
        console.log('StreamrTvBroadcaster::start()', streamId);
        this.streamId = streamId;
        await this.streamrWrapper.start(`${streamId}#0`);
        this.viewerCounter.start();
        this.viewerInfoIntervalRef = setInterval(() => {
            this.streamrWrapper.publishViewerInfo({
                viewerCount: this.viewerCounter.getCount(),
            });
            console.log('ViewerInfo, count:', this.viewerCounter.getCount(), 'neighbors:', this.viewerCounter.getNeighborCounts(), 'upload:', this.viewerCounter.getUploadRates(), 'download:', this.viewerCounter.getDownloadRates());
        }, Settings.viewerInfoInterval);
    }
    async stop() {
        await this.streamrWrapper.stop();
        this.viewerCounter.stop();
        this.mediaProducer.stop();
        if (this.viewerInfoIntervalRef) {
            clearInterval(this.viewerInfoIntervalRef);
        }
    }
    async startMediaProducer(mediaStream) {
        await this.mediaProducer.start(mediaStream);
    }
    async stopMediaProducer() {
        console.log('StreamrTvBroadcaster::stopMediaProducer()');
        this.mediaProducer.stop();
    }
    setVideoEncodingQuality(videoEncodingQuality) {
        console.log('StreamrTvBroadcaster::setVideoEncodingQuality()', videoEncodingQuality);
        this.mediaProducer.setVideoEncodingQuality(videoEncodingQuality);
    }
    getVideoEncodingQuality() {
        return this.mediaProducer.getVideoEncodingQuality();
    }
}
